import { render, staticRenderFns } from "./FundingDetailsLink.vue?vue&type=template&id=3d244aa4"
import script from "./FundingDetailsLink.vue?vue&type=script&lang=js"
export * from "./FundingDetailsLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports